// @ts-expect-error no declarations found for module
import { getSectionById } from 'EmailEditorUI/redux/selectors/sectionSelectors';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { isHiddenForDefaultBreakpoint, isHiddenForMobileBreakpoint } from 'EmailEditorUI/utils/breakpointUtils';
import CommentableArea from 'LayoutBuilderUI/components/utility/CommentableArea';
import { jsx as _jsx } from "react/jsx-runtime";
function SectionCommentableArea({
  children,
  sectionId
}) {
  const section = useSelector(state => getSectionById(state, sectionId));
  if (!section) {
    return null;
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(CommentableArea, {
      className: classNames('commentable-hse-section', isHiddenForDefaultBreakpoint(section.get('style')) && 'hs-hd', isHiddenForMobileBreakpoint(section.get('style')) && 'hs-hm'),
      moduleId: sectionId,
      verticalPositioning: true,
      description: {
        translationKey: 'emailSection'
      },
      children: children
    })
  );
}
export default SectionCommentableArea;